// extracted by mini-css-extract-plugin
export var currencyInput = "_jx-1";
export var currencySymbol = "_jx-0";